import type { ReferralFieldName } from '../../../../../common';
import type { IntakeReferralPayload } from '../../../../../../store/questionnaires/intake';

export const REFERRAL_TEXT_MIN_LENGTH = 4;

// Maps the shared referral form field names to the intake API payload keys.
export const INTAKE_REFERRAL_PAYLOAD_FIELDS = {
  referral_date: 'diagnosis_date',
  provider_name: 'provider_name',
  diagnosis_tool: 'diagnosis_tool',
  city: 'diagnosis_city',
  state: 'diagnosis_state',
} satisfies Record<ReferralFieldName, keyof IntakeReferralPayload>;
